export default __webpack_public_path__ + "media/images/about-image-4d53de243c522cded9f6a9bc86c24cf0.jpg";